/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  HStack,
  ScaleFade,
  Skeleton,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import React, { useContext } from 'react';
import AppColors from '../../../../constants/AppColors';
import { FONT_FAMILY } from '../../../../constants/Theme';
import { PhysicianContext } from '../../../../providers/PhysicianProvider';
import RVUOpportunity from '../../components/RVUOpportunity';
import InfoTooltip from '../../../../components/InfoTooltip';

function PrvuOpporturnity({
  defaultStartDate,
  defaultEndDate,
  filter,
  isTileModalOpen,
  setChecked,
  checked,
  radioClick,
  practiceChartData,
  stateChartData,
  auditChartData,
  extraRVUData,
  dropdown,
  weightedAvg,
}) {
  const { isRvuLoading, error } = useContext(PhysicianContext);

  const renderRVUOpp = () => {
    return (
      <ScaleFade initialScale={0.5} in={true}>
        <Box
          bg={AppColors.white}
          borderRadius={'md'}
          padding={4}
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'space-between'}
        >
          {/* header */}
          <HStack justifyContent={'space-between'}>
            <Text
              fontSize={'sm'}
              fontFamily={FONT_FAMILY.ptSans}
              color={AppColors.primary}
            >
              E&M Distribution
            </Text>
            <InfoTooltip id="tour-icon-rvu" infoContent={
              <>
                <p>
                  <b>Relative Value Units (RVU)</b> for your practice compared to state-level bell curve distributions. RVUs, help you measure productivity and efficiency by comparing your practice's performance against broader benchmarks.
                </p>
              </>} />
          </HStack>
          <Box mt={5}>
            <RVUOpportunity
              stateChartData={stateChartData}
              practiceChartData={{ ...practiceChartData, text: 'Provider' }}
              auditChartData={auditChartData}
              extraRVUData={extraRVUData}
              checked={checked}
              setChecked={setChecked}
              radioClick={radioClick}
              tile={isTileModalOpen}
              dropdown={dropdown}
              weightedAvgData={weightedAvg}
            />
          </Box>
        </Box>
      </ScaleFade>
    );
  };

  const renderFailedPage = message => {
    return (
      <VStack justifyContent={'center'} h={'100%'} textAlign={'center'}>
        <Text>
          {message ? message : 'Something went wrong, Please try again later'}
        </Text>
      </VStack>
    );
  };

  const renderLoader = () => {
    return (
      <Stack p={4}>
        <Skeleton height="20px" />
        <Skeleton height="20px" />
        <Skeleton height="20px" />
      </Stack>
    );
  };

  const renderMainContent = () => {
    if (isRvuLoading) {
      return renderLoader();
    } else if (error['RVU_OPPORTUNITY']) {
      return renderFailedPage(error['RVU_OPPORTUNITY']);
    } else {
      return renderRVUOpp();
    }
  };

  return renderMainContent();
}

export default PrvuOpporturnity;
